module.exports = __webpack_public_path__ + "static/media/refillCartMsg.5fd1b228.png";